module.exports = __webpack_public_path__ + "img/zm.dd9dbd96.svg";